import { decodeStyle, mobile, parseStyle, tablet } from "../../../juntion";

function Divider({ id, db, gs, device }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const dwebStyle = decodeStyle(ps.style, gs);
    const dmobileStyle = decodeStyle(mobileStyle, gs);

    let color = dwebStyle.color;
    if (mobile(device)) {
        color = dmobileStyle.color;
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    ...decodeStyle(ps.fixStyle, gs),
                    ...decodeStyle(ps.style, gs),
                    // "&:hover": decodeStyle(ps.hover),
                    ...(tablet(device) && decodeStyle(tabletStyle, gs)),
                    ...(mobile(device) && decodeStyle(mobileStyle, gs)),
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <hr
                    style={{
                        width: `${input.dividerWidth}%`,
                        maxWidth: "100%",
                        alignSelf: input.alignment,
                        borderTop: `${input.thickness * 0.5}px ${
                            input.lineStyle === "rounded"
                                ? "solid"
                                : input.lineStyle
                        } ${color}`,
                        borderRadius: `${
                            input.lineStyle === "rounded" ? 100 : 0
                        }px`,
                        margin: 0,
                    }}
                ></hr>
            </div>
        </div>
    );
}

export default Divider;
